<template>
  <b-row>
    <b-col>
      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao-contrato
            :titulo="'Certificado Digital'"
            :descricao="'Aqui deve ser informado o tipo de certificado utilizado e as demais informações solicitadas'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                3
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>
      <b-row class="mb-50">
        <b-col>
          <span>Selecione o certificado</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-btn
            variant="none"
            size="sm"
            :class="selecionadoA1 ? 'btn-primary': 'btn-light'"
            style="padding-bottom: 0rem;padding-right: 0.3rem;padding-left: 0.3rem;border-radius: 10px;"
            :disabled="desabilitarCampos"
            @click="selecaoA1"
          >
            <p style="font-weight: bold;font-size: 18px;">
              Certificado A1</p>
            <p>
              Esse certificado é um arquivo digital e a assinatura fica armazenada no próprio computador do usuário</p>
          </b-btn>
        </b-col>
        <b-col cols="6">
          <b-btn
            variant="none"
            size="sm"
            :class="selecionadoA3 ? 'btn-certificado': 'btn-light'"
            style="padding-bottom: 0rem;padding-right: 0.3rem;padding-left: 0.3rem;border-radius: 10px;"
            :disabled="desabilitarCampos"
            @click="selecaoA3"
          >
            <p style="font-weight: bold;font-size: 18px;">
              Certificado A3</p>
            <p>
              Para a entrega das obrigações acessórias providenciar Certificado Digital modelo A1</p>
          </b-btn>
        </b-col>
      </b-row>
      <b-row
        v-if="selecionadoA1 || selecionadoA3"
        class="mt-1"
      >
        <b-col cols="6">
          <upload-parametrizacao
            v-if="selecionadoA1"
            ref="uploadCertificado"
            :label="'Anexe o certificado digital aqui'"
            :id-upload="'certificado'"
            :text="valueInner.nomeArquivoCertificado"
            :visualizar="visualizarCertificado"
            :certificado="true"
            :disabled="desabilitarCampos"
            :show-visualizacao="false"
            :value-certificado="valueInner.certificado"
            @selecionado="selecionadoCertificado"
            @removido="arquivoCertificadoRemovido"
          />
        </b-col>
        <b-col
          v-if="selecionadoA3"
          cols="6"
        />
      </b-row>
      <b-row
        v-if="selecionadoA1"
        class="mt-1"
      >
        <b-col cols="6">
          <b-form-group label="Senha">
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Senha"
            >
              <senha-input
                v-model="valueInner.senhaCertificado"
                :blur-function="validarCertificado"
                :disabled="desabilitarCampos"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="selecionadoA1"
      >
        <b-col cols="3">
          <b-form-group label="Data de Vencimento">
            <data-input
              v-model="valueInner.dataVencimentoCertificado"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="tipoProposta === 'constituicao' && !filial">
        <b-col>
          <b-form-checkbox
            v-model="valueInner.semCertificado"
            :disabled="desabilitarCampos"
            @change="limparCamposCertificado"
          >
            Sem certificado digital
          </b-form-checkbox>
        </b-col>
      </b-row>

      <!-- Anexos -->
      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao-contrato
            :titulo="'Anexos'"
            :descricao="'Aqui você pode adicionar o anexo da última alteração contratual e outros anexos que julgar importante'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                4
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="(tipoProposta !== 'constituicao') || (tipoProposta === 'constituicao' && filial)"
          cols="6"
        >
          <div style="display:flex;">
            <div>
              <legend style="font-size: 14px;">
                Última Alteração Contratual</legend>
            </div>
            <div
              v-if="tipoProposta === 'constituicao' && filial"
              style="padding-left: 0.4rem"
            >
              <i
                v-b-tooltip.hover
                title="Quando a proposta é de constituição de filial, anexar a última alteração contratual da Matriz."
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <upload-parametrizacao
            ref="uploadContratual"
            :label="''"
            :id-upload="'contratual'"
            :visualizar="visualizarContratual"
            :show-label="false"
            :require="true"
            :text="valueInner.nomeArquivoContratual"
            :disabled="desabilitarCampos"
            @selecionado="selecionadoContratual"
            @removido="arquivoContratualRemovido"
          />
        </b-col>
        <b-col cols="6">
          <upload-parametrizacao
            ref="uploadOutrosAnexos"
            :label="'Outros Anexos (opcional)'"
            :id-upload="'outrosAnexos'"
            :visualizar="visualizarOutros"
            :show-label="false"
            :require="false"
            :text="valueInner.nomeArquivoOutrosAnexos"
            :disabled="desabilitarCampos"
            @selecionado="selecionadoOutros"
            @removido="arquivoOutrosRemovido"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<style lang="scss">

.btn-certificado {
  background-color: #ea5455;
  border-color: white;
  color: white;
}

.btn-certificado:focus {
  background-color: #ea5455;
  border-color: white;
  color: white;
}

.btn-certificado:hover {
  background-color: #ea5455;
  border-color: white;
  color: white;
}
.btn-certificado:active {
  background-color: white;
  filter: brightness(90%)
}
</style>
<script>
import { ValidationProvider } from 'vee-validate'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'

export default {
  name: 'CertificadoDigitalEAnexo',
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    DivisoriaDescricaoContrato: () => import('@/shared/components/divisoria-descricao-contrato/DivisoriaDescricaoContrato.vue'),
    UploadParametrizacao: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/Geral/shared/upload-visualizacao-parametrizacao/UploadParametrizacao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    tipoProposta: {
      type: String,
      default: '',
    },
    filial: {
      type: Boolean,
      default: false,
    },
    preGeracaoId: {
      type: Number,
      default: 0,
    },
    desabilitarCampos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faQuestionCircle,
      selecionadoA3: false,
      selecionadoA1: false,
      valueInner: {
        certificadoSelecionado: false,
        contratualSelecionado: false,
        outrosSelecionado: false,
        certificado: [],
        senhaCertificado: null,
        tipoCertificado: null,
        dataVencimentoCertificado: null,
        certificadoFisico: null,
        nomeArquivoContratual: null,
        nomeArquivoOutrosAnexos: null,
        nomeArquivoCertificado: null,
        semCertificado: false,
        excluirContratual: false,
      },
      senhaIncorreta: false,
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.certificadoSelecao()
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.certificadoSelecao()
  },
  methods: {
    certificadoSelecao() {
      if (this.valueInner.id > 0) {
        if (this.valueInner.tipoCertificado.toLowerCase() === 'a1') {
          this.selecionadoA1 = true
          this.selecionadoA3 = false
        } else if (this.valueInner.tipoCertificado.toLowerCase() === 'a3') {
          this.selecionadoA1 = false
          this.selecionadoA3 = true
        }
      }
    },
    selecionadoCertificado(nome) {
      this.valueInner.certificadoSelecionado = this.$refs.uploadCertificado.value[0] !== undefined
      this.$set(this.valueInner, 'nomeArquivoCertificado', nome)
      this.$set(this.valueInner, 'senhaCertificado', null)
      this.$set(this.valueInner, 'dataVencimentoCertificado', null)
    },
    selecionadoContratual(nome) {
      this.valueInner.contratualSelecionado = this.$refs.uploadContratual.value[0] !== undefined
      this.valueInner.nomeArquivoContratual = nome
      this.valueInner.excluirContratual = false
    },
    selecionadoOutros(nome) {
      this.valueInner.outrosSelecionado = this.$refs.uploadOutrosAnexos.value[0] !== undefined
      this.valueInner.nomeArquivoOutrosAnexos = nome
      this.valueInner.excluirOutros = false
    },
    visualizarCertificado() {
    },
    visualizarContratual() {
      if (this.preGeracaoId > 0) {
        return api.getArquivoContratual(this.preGeracaoId)
      }
      return null
    },
    visualizarOutros() {
      if (this.preGeracaoId > 0) {
        return api.getArquivoOutros(this.preGeracaoId)
      }
      return null
    },
    selecaoA1() {
      this.selecionadoA1 = true
      this.selecionadoA3 = false
      this.valueInner.tipoCertificado = 'a1'
    },
    selecaoA3() {
      this.selecionadoA1 = false
      this.selecionadoA3 = true
      this.valueInner.tipoCertificado = 'a3'

      this.$set(this.valueInner, 'dataVencimentoCertificado', null)
      this.$set(this.valueInner, 'senhaCertificado', null)
      this.$set(this.valueInner, 'certificadoSelecionado', false)
      this.$set(this.valueInner, 'certificado', [])
      this.$set(this.valueInner, 'senhaIncorreta', false)
      this.$set(this.valueInner, 'anexoVencido', false)
      this.$set(this.valueInner, 'nomeArquivoCertificado', null)
    },
    validarCertificado() {
      this.$set(this.valueInner, 'senhaIncorreta', false)
      this.$set(this.valueInner, 'anexoVencido', false)
      if (this.valueInner.nomeArquivoCertificado !== '' && (this.valueInner.senhaCertificado && this.valueInner.senhaCertificado !== '')) {
        const fileCertificado = this.$refs.uploadCertificado.value[0]
        api.validaCertificado(fileCertificado, this.valueInner.senhaCertificado)
          .then(payload => {
            const data = new Intl.DateTimeFormat('pt-BR').format(new Date(payload.data))
            this.$set(this.valueInner, 'dataVencimentoCertificado', data)
          })
          .catch(err => {
            if (err !== null) {
              const resolved = this.$resolveError(err)
              const message = resolved.detail || resolved.title || err.message || ''
              this.valueInner.senhaIncorreta = message === 'Senha incorreta!'
              this.valueInner.anexoVencido = message === 'Não é permitido anexar certificado vencido!'
              this.$handleError(err)
            }
          })
      }
    },
    mostrarMensagem() {
      this.$confirmar(
        'Prezado, é de extrema importância que seja realizado o envio do certificado A3 para nossa equipe, somente com o certificado físico em mãos poderemos dar andamento nos processos de sua empresa.',
        'Somente com ele conseguimos realizar as obrigações acessórias de sua empresa, sendo ela com movimento/ou não, caso deseje agilizar esta demanda e evitar correr riscos, sugerimos adquirir o e-CNPJ modelo A1, otimizando as entregas e diminuindo os riscos por falta dele!',
        'success', '',
      )
    },
    limparCamposCertificado(value) {
      if (value) {
        if (this.$refs.uploadCertificado) {
          this.$refs.uploadCertificado.value = null
        }
        this.selecionadoA3 = false
        this.selecionadoA1 = false
        this.valueInner.certificadoSelecionado = false
        this.valueInner.certificado = []
        this.valueInner.senhaCertificado = null
        this.valueInner.tipoCertificado = null
        this.valueInner.dataVencimentoCertificado = null
        this.valueInner.certificadoFisico = null
        this.valueInner.nomeArquivoCertificado = null
        this.valueInner.senhaIncorreta = false
        this.valueInner.anexoVencido = false
      }
    },
    getArquivosAnexados() {
      return {
        certificado: this.selecionadoA1 && this.$refs.uploadCertificado ? this.$refs.uploadCertificado.value[0] : null,
        contratual: this.$refs.uploadContratual ? this.$refs.uploadContratual.value[0] : null,
        outros: this.$refs.uploadOutrosAnexos ? this.$refs.uploadOutrosAnexos.value[0] : null,
      }
    },
    arquivoContratualRemovido() {
      this.valueInner.contratualSelecionado = false
      this.valueInner.nomeArquivoContratual = ''
      this.valueInner.excluirContratual = true
    },
    arquivoOutrosRemovido() {
      this.valueInner.outrosSelecionado = false
      this.valueInner.nomeArquivoOutrosAnexos = ''
      this.valueInner.excluirOutros = true
    },
    arquivoCertificadoRemovido() {
      this.valueInner.certificadoSelecionado = false
      this.$set(this.valueInner, 'nomeArquivoCertificado', '')
      this.valueInner.certificado = []
      this.$set(this.valueInner, 'senhaCertificado', null)
      this.$set(this.valueInner, 'dataVencimentoCertificado', null)
    },
  },
}
</script>
